import React, { Component, lazy } from 'react';
import Markdown from 'markdown-to-jsx';

import { componentLoader } from '../../../../utils/src';

import { SuccessGreenTickIcon } from '../../icons/SuccessGreenTickIcon';

import { Image } from '../Image';
import {
  ChecklistWithTitle,
  CustomList,
  NxtwaveWhiteLogo,
  RegisterButton,
  TestimonialsContainer
} from '../MarkDownComponents';

const ImageSlick = lazy(() =>
  componentLoader(
    () => import(/* webpackChunkName: "ImageSlick" */ '../ImageSlickComponent')
  )
);

interface CustomMarkdownInterface {
  content: string;
  onClickRegister?: () => void;
}

class CustomMarkdown extends Component<CustomMarkdownInterface> {
  override render() {
    const { content, onClickRegister } = this.props;

    const RegisterButtonWrapper: React.FC<any> = (props) => {
      return <RegisterButton {...props} onClickRegister={onClickRegister} />;
    };

    return (
      <Markdown
        options={{
          overrides: {
            ImageSlick: {
              component: ImageSlick
            },
            NxtwaveWhiteLogo: {
              component: NxtwaveWhiteLogo
            },
            GreenTickIcon: {
              component: SuccessGreenTickIcon
            },
            Image: {
              component: Image
            },
            ChecklistWithTitle: {
              component: ChecklistWithTitle
            },
            CustomList: {
              component: CustomList
            },
            RegisterButton: {
              component: RegisterButtonWrapper
            },
            TestimonialsContainer: {
              component: TestimonialsContainer
            }
          }
        }}
      >
        {content}
      </Markdown>
    );
  }
}
export default CustomMarkdown;
